<template>
    <div class="vx-flex vx-flex-col vx-items-center vx-gap-8">
        <div
            class="gradient-mask vx-relative vx-flex vx-max-w-fit vx-gap-2 vx-transition vx-duration-500 vx-ease-out">
            <div
                v-for="item in 40"
                :key="item"
                class="vx-h-14 vx-min-w-[8px] vx-overflow-hidden vx-rounded-full">
                <div
                    class="vx-flex vx-h-full vx-w-full vx-origin-bottom vx-rounded-t-full vx-transition vx-duration-300 vx-will-change-transform"
                    :class="[
                        item % 7 ? (item % 3 ? 'vx-translate-y-8' : 'vx-translate-y-4') : '',
                        'vx-bg-slate-300',
                        'motion-safe:vx-animate-[pulse_1.3s_infinite]',
                    ]"
                    :style="
                        item % 7
                            ? item % 5
                                ? 'animation-delay: 0s'
                                : 'animation-delay: .2s'
                            : 'animation-delay: .4s'
                    "
                />
            </div>
        </div>
        <div v-if="props.withText" class="vx-text-lg vx-font-semibold vx-text-slate-400">Loading</div>
    </div>
</template>

<script setup>
const props = defineProps({
    withText: {
        type: Boolean,
        default: true,
    },
});
</script>

<style scoped>
.gradient-mask {
    -webkit-mask-image: linear-gradient(
        to right,
        transparent,
        black 20%,
        black 80%,
        transparent
    );
    mask-image: linear-gradient(
        to right,
        transparent,
        black 20%,
        black 80%,
        transparent
    );
}
</style>
